import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import "./AboutHero.css";
import heroImage from "../../Assets/community.jpg";

const AboutHero = () => {
  // Animation variants
  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
  };

  const fadeRight = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
  };

  const fadeLeft = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } },
  };

  return (
    <section className="about-hero">
      <div className="grid-pattern"></div>

      <div className="hero-content">
        {/* Header */}
        <motion.div
          className="hero-header"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
        >
          <span className="hero-badge">About Us</span>
          <h1>Simba Education Consultants</h1>
          <p>
            We integrate counselling, community outreach, and sustainable development
            to create meaningful impact across personal and societal levels.
          </p>
        </motion.div>

        {/* Main Section */}
        <div className="hero-main">
          {/* Left Column */}
          <motion.div
            className="hero-text"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeRight}
          >
            <h2>Empowering individuals. Elevating communities.</h2>
            <p>
              At Simba Education Consultants, we foster educational opportunities,
              strengthen human capacity, and address emerging issues in health and
              livelihoods. Our goal is to support both institutions and individuals
              with tools, insights, and direction needed for growth and success.
            </p>

            <div className="mission-vision">
              <div>
                <h3>Our Mission</h3>
                <ul>
                  <li>To support research & strategy development for institutions</li>
                  <li>To build human capacity and improve livelihoods</li>
                  <li>To address emerging issues in health, education and development</li>
                </ul>
              </div>
              <div>
                <h3>Our Vision</h3>
                <ul>
                  <li>A society where education fuels sustainable development</li>
                  <li>Empowered individuals driving positive change</li>
                  <li>Institutions equipped to respond to tomorrow’s challenges</li>
                </ul>
              </div>
            </div>
          </motion.div>

          {/* Right Column */}
          <motion.div
            className="hero-image"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeLeft}
          >
            <div className="image-wrapper">
              <img
                src={heroImage}
                alt="Simba Education community outreach"
                loading="lazy"
              />
              <div className="image-card">
                <p className="card-title">Looking to study internationally?</p>
                <p className="card-sub">
                  Apply for a scholarship to study in <br /> Russia & China
                </p>
                <Link to="/" className="join-btn">
                  Apply Now
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
